import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState(
        { // ストレージのキーを指定。デフォルトではvuex
          key: 'vuex',    
          // ストレージの種類を指定する。デフォルトではローカルストレージ
          storage: window.sessionStorage
        }
      )],
    state: {
        Sidebar_drawer: null,
        Customizer_drawer: false,
        SidebarColor: '#1d2228', //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
        SidebarBg: '',
        navbarColor:'white',
        userData:null,
        userPhotoUrl:null,
        companyId : null,
        isStripeLoaded : false,
        companyData : null,
    },
    mutations: {
        SET_SIDEBAR_DRAWER(state, payload) {
            state.Sidebar_drawer = payload
        },
        SET_CUSTOMIZER_DRAWER(state, payload) {
            state.Customizer_drawer = payload
        },
        SET_SIDEBAR_COLOR(state, payload) {
            state.SidebarColor = payload
        },
        SET_NAVBAR_COLOR(state, payload) {
            state.navbarColor = payload
        },
        SET_USERDATA(state, payload) {
            state.userData = payload
        },
        SET_USERPHOTOURL(state,payload){
            state.userPhotoUrl = payload
        },
        SET_COMPANYID(state,payload){
            state.companyId = payload
        },
        SET_IS_STRIPE_LOADED(state,payload){
            state.isStripeLoaded = payload
        },
        SET_COMPANYDATA(state,payload){
            state.companyData = payload
        },
        RESET_ALLDATA(state){
            state.userData = null;
            state.userPhotoUrl = null;
            state.companyId = null;
            state.isStripeLoaded = false;
            state.companyData = null;
        },
    },
    actions: {
    },
    getters: {
    }
})